import React from 'react'

const PopupContext = React.createContext({
    popupProps: false,
    setPopupProps: () => {},
    reset: () => {},
})

export default PopupContext
